// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__37rsu","left":"InfoRow_left__1CPy4"};